import PropTypes from 'prop-types';

import DislikeButton from './DislikeButton';
import LikeButton from './LikeButton';
import ReplyButton from './ReplyButton';
import ToggleRepliesButton from './ToggleRepliesButton';

const CommentItemFooter = ({
  commentId,
  commentLikes,
  hasReply,
  isDisliked,
  isLiked,
  isReply,
  isShowingReplies,
  onDislike,
  onLike,
  onReply,
  onToggleReplies,
}) => (
  <div className="mt-1 flex items-center justify-between">
    <div className="flex items-center gap-x-1 md:gap-x-2">
      <LikeButton isLiked={isLiked} onClick={onLike}>
        {commentLikes}
      </LikeButton>
      <DislikeButton isDisliked={isDisliked} onClick={onDislike} />
      {(!isReply || (!hasReply && isReply)) && (
        <ReplyButton onClick={onReply} />
      )}
    </div>
    {hasReply && !isReply && (
      <ToggleRepliesButton
        commentId={commentId}
        isShowingReplies={isShowingReplies}
        onToggleReplies={onToggleReplies}
      />
    )}
  </div>
);

CommentItemFooter.propTypes = {
  commentId: PropTypes.number.isRequired,
  commentLikes: PropTypes.number.isRequired,
  hasReply: PropTypes.bool.isRequired,
  isDisliked: PropTypes.bool.isRequired,
  isLiked: PropTypes.bool.isRequired,
  isReply: PropTypes.bool.isRequired,
  isShowingReplies: PropTypes.bool.isRequired,
  onDislike: PropTypes.func.isRequired,
  onLike: PropTypes.func.isRequired,
  onReply: PropTypes.func.isRequired,
  onToggleReplies: PropTypes.func.isRequired,
};

export default CommentItemFooter;
